export function Zip<T extends unknown[][]>(
  ...args: T
): { [K in keyof T]: T[K] extends (infer U)[] ? U : never }[] {
  if (args.length === 0) return []

  const shortest = args.reduce((a, b) => (a.length < b.length ? a : b))

  return shortest.map((_, i) => args.map(array => array[i]) as any)
}
